import { memo } from "react";

import { Modal } from "../Modal";
import { RemoveWaveErrorAction } from "./RemoveWaveErrorAction";
import { RemoveWaveErrorContent } from "./RemoveWaveErrorContent";

export const RemoveWaveError = memo(({ open, onClose }) => {
  const handleClick = () => {
    onClose && onClose();
  };

  return (
    <Modal
      open={open}
      title={"Error"}
      onClose={onClose}
      maxWidth={"xs"}
      content={<RemoveWaveErrorContent />}
      actions={<RemoveWaveErrorAction onCancel={handleClick} />}
    />
  );
});

export default RemoveWaveError;
